<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ "trips.activity.experience" | translate }}</h2>
<!-- Global form-level validation error -->
<validation-error-bar
  [formGroup]="form"
  [validationMessages]="{
    atLeastOneRequired: 'experiences.required-at-least-one-price'
  }"
  [relevantControls]="['pricePerPerson', 'pricePerGroup']"
></validation-error-bar>
<ng-container *ngIf="form">
  <mat-dialog-content [formGroup]="form" class="dialog-content">
    <div class="grid-container">
      <!-- Title (name) (Read-Only) -->
      <mat-form-field
        appearance="outline"
        class="mat-form-field-readonly span-2-cols"
      >
        <mat-label class="label-text-readonly">{{
          "experiences.title" | translate
        }}</mat-label>
        <input matInput formControlName="name" readonly />
      </mat-form-field>

      <!-- Supplier (legalName) (Read-Only) -->
      <mat-form-field
        appearance="outline"
        class="mat-form-field-readonly span-2-cols"
      >
        <mat-label class="label-text-readonly">{{
          "supplier" | translate
        }}</mat-label>
        <input matInput formControlName="legalName" readonly />
      </mat-form-field>

      <!-- Starting time -->
      <input-time
        formFieldClass="span-2-cols"
        formControlName="startTime"
        label="start-time"
        [required]="true"
        appCombinedReadonly
        #pricePerPersonReadonly="appCombinedReadonly"
        [forbiddenRoles]="['TRAVEL_DESIGNER']"
        [forbiddenStates]="['PAID_BY_CUSTOMER']"
        [combineMode]="'AND'"
      ></input-time>

      <!-- End time (readonly) automatically updated with startingtime + duration-->
      <input-time
        formFieldClass="span-2-cols"
        formControlName="endTime"
        label="end-time"
        [readonly]="true"
      ></input-time>

      <!-- Meeting Point -->
      <input-link
        formFieldClass="span-2-cols"
        formControlName="meetingPoint"
        [label]="'meeting-point'"
      ></input-link>

      <!-- Duration -->
      <duration-select
        formControlName="duration"
        [required]="true"
      ></duration-select>

      <!-- Price Per Person -->
      <input-monetary-amount
        formControlName="pricePerPerson"
        [label]="'experiences.price-per-person'"
        appCombinedReadonly
        #pricePerPersonReadonly="appCombinedReadonly"
        [forbiddenRoles]="['ACCOUNTANT']"
        [forbiddenStates]="['PAID_BY_CUSTOMER']"
        [combineMode]="'AND'"
      >
      </input-monetary-amount>

      <!-- Price Per Group -->
      <input-monetary-amount
        formControlName="pricePerGroup"
        [label]="'experiences.price-per-group'"
        appCombinedReadonly
        #pricePerGroupReadonly="appCombinedReadonly"
        [forbiddenRoles]="['ACCOUNTANT']"
        [forbiddenStates]="['PAID_BY_CUSTOMER']"
        [combineMode]="'AND'"
      >
      </input-monetary-amount>

      <!-- Number of total participants -->
      <input-number
        formControlName="totalParticipants"
        [label]="'trips.total-participants'"
        [requiredLabel]="'trips.total-participants-required'"
        [required]="true"
        [minValue]="1"
        [onlyInteger]="true"
      ></input-number>

      <!-- Guide -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{ "experiences.guide" | translate }}</mat-label>
        <input matInput formControlName="guide" />
      </mat-form-field>

      <input-phone formControlName="phone" [required]="true"></input-phone>

      <!-- Description -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{ "description" | translate }}</mat-label>
        <textarea
          appCombinedReadonly
          [forbiddenRoles]="['TRAVEL_DESIGNER']"
          matInput
          formControlName="description"
          maxlength="300"
          rows="3"
        ></textarea>
        <mat-hint
          >{{ form.get("description")?.value?.length || 0 }}/300</mat-hint
        >
      </mat-form-field>

      <!-- Disclaimer -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{ "disclaimer" | translate }}</mat-label>
        <textarea
          appCombinedReadonly
          [forbiddenRoles]="['TRAVEL_DESIGNER']"
          matInput
          formControlName="disclaimer"
          maxlength="300"
          rows="3"
        ></textarea>
        <mat-hint
          >{{ form.get("disclaimer")?.value?.length || 0 }}/300</mat-hint
        >
      </mat-form-field>

      <!-- Notes -->
      <mat-form-field appearance="outline" class="span-4-cols">
        <mat-label>{{ "notes" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="notes"
          maxlength="500"
          rows="3"
        ></textarea>
        <mat-hint>{{ form.get("notes")?.value?.length || 0 }}/500</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-content">
    <button mat-button (click)="cancel()">{{ "cancel" | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      [disabled]="!form.valid"
    >
      {{ "confirmation" | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>
